import { BrowserModule } from '@angular/platform-browser';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';

import { environment } from '@env/environment';
import { CoreModule } from '@core';
import { SharedModule } from '@shared';
import { AuthModule } from '@app/auth';
import { ShellModule } from './shell/shell.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TermsPopupComponent } from './terms-popup/terms-popup.component';
import { DashboardModule } from './dashboard/dashboard.module';
import ar from '@angular/common/locales/ar';
import { registerLocaleData } from '@angular/common';
import { PaymentModule } from './payment/payment.module';
import { AhoyCustomerModule } from './ahoy-customer/ahoy-customer.module';
import { AhoyAnalyticsModule } from './ahoy-analytics/ahoy-analytics.module';
import { LanguageService } from './@core/services/language.service';

registerLocaleData(ar);

@NgModule({
  declarations: [AppComponent, TermsPopupComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('./ngsw-worker.js', {
      enabled: environment.production,
    }),
    FormsModule,
    TranslateModule.forRoot(),
    BrowserAnimationsModule,
    MaterialModule,
    CoreModule,
    SharedModule,
    ShellModule,
    DashboardModule,
    PaymentModule,
    AuthModule,
    AppRoutingModule, // must be imported as the last module as it contains the fallback route,
    AhoyCustomerModule,
    AhoyAnalyticsModule,
  ],
  providers: [
    // Must run before the first component so overlays pick up RTL too.
    provideAppInitializer(() =>
      inject(LanguageService).applyInitialHtmlDirection(),
    ),
    provideHttpClient(withInterceptorsFromDi()),
    ...(environment.enableGoogleAnalytics
      ? [
          provideFirebaseApp(() => initializeApp(environment.firebase)),
          provideAnalytics(() => getAnalytics()),
        ]
      : []),
  ],
})
export class AppModule {}
